var React = require('react');

function SendEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.531483 6.1716C0.273567 6.67003 0.464638 7.28521 0.958252 7.54565L5.16924 9.76739L7.27307 14.0197C7.37699 14.2298 7.54963 14.3971 7.76173 14.4934C8.2697 14.724 8.8666 14.4951 9.09494 13.9821L14.4946 1.85251C14.6098 1.59377 14.6129 1.29825 14.5031 1.03713C14.2855 0.519469 13.6935 0.277973 13.1808 0.497729L1.03119 5.70586C0.816243 5.798 0.639625 5.96261 0.531483 6.1716ZM5.76452 8.08341L10.1847 3.70592L3.16828 6.71362L5.76452 8.08341ZM6.94522 9.39456L8.13964 11.8088L11.0036 5.37543L6.94522 9.39456Z","fill":"white"}));
}

SendEmail.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = SendEmail;

SendEmail.default = SendEmail;
